import { Badge } from '@/components/ui/badge';
import { Bot, UserCheck, Clock, CheckCircle2, MessageSquare } from 'lucide-react';

export type StatusType =
  | 'AI_HANDLING'
  | 'HUMAN_ASSIGNED'
  | 'WAITING'
  | 'UNREAD'
  | 'CLOSED'
  | 'ai'
  | 'assigned'
  | 'queue'
  | 'resolved'
  | 'unread'
  | string;

interface StatusBadgeProps {
  status: StatusType;
  className?: string;
  showIcon?: boolean;
}

export function StatusBadge({
  status,
  className,
  showIcon = true,
}: StatusBadgeProps) {
  const normalized = status.toUpperCase();

  switch (normalized) {
    case 'AI_HANDLING':
    case 'AI':
    case 'AIHANDLING':
    case 'ACTIVE':
      return (
        <Badge variant="ai" className={className}>
          {showIcon && <Bot className="h-3 w-3 mr-1" />}
          IA Atendendo
        </Badge>
      );
    case 'HUMAN_ASSIGNED':
    case 'ASSIGNED':
    case 'HUMANASSIGNED':
      return (
        <Badge variant="agent" className={className}>
          {showIcon && <UserCheck className="h-3 w-3 mr-1" />}
          Humano Atribuído
        </Badge>
      );
    case 'WAITING':
    case 'QUEUE':
    case 'WAITINGFORHUMAN':
    case 'WAITING_FOR_HUMAN':
    case 'WAITING FOR HUMAN':
      return (
        <Badge variant="waiting" className={className}>
          {showIcon && <Clock className="h-3 w-3 mr-1" />}
          Aguardando
        </Badge>
      );
    case 'UNREAD':
      return (
        <Badge variant="unread" className={className}>
          {showIcon && <MessageSquare className="h-3 w-3 mr-1" />}
          Não Lida
        </Badge>
      );
    case 'CLOSED':
    case 'RESOLVED':
      return (
        <Badge variant="closed" className={className}>
          {showIcon && <CheckCircle2 className="h-3 w-3 mr-1" />}
          Fechada
        </Badge>
      );
    default:
      return (
        <Badge variant="secondary" className={className}>
          {status}
        </Badge>
      );
  }
}
